<div
  [hidden]="!active"
  class="base-tab-content"
  [class.detail-modal]="detailLayout"
  [class.activity-log]="activityLogLayout"
>
  <ng-content></ng-content>
</div>
